import { logger } from './logger.util';

/**
 * Copies text to the system clipboard using the Async Clipboard API.
 * @param text - String to copy
 * @returns Promise that resolves to true if the copy succeeded, false otherwise
 */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  if (!text) {
    return false;
  }

  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    logger.error('Error copying to clipboard', { error }, error as Error);
    return false;
  }
}
